import { render, staticRenderFns } from "./CreateRegional.vue?vue&type=template&id=5b925b58"
import script from "./CreateRegional.vue?vue&type=script&lang=js"
export * from "./CreateRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports